import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celcius");
  function showFarhenheit(event) {
    event.preventDefault();
    setUnit("farhenheit");
  }
  function showCelcius(event) {
    event.preventDefault();
    setUnit("celcius");
  }
  if (unit === "celcius") {
    return (
      <div className="WeatherTemperature">
        <span className="temperature">{Math.round(props.celsius)}</span>
        <span className="unit">
          °C |{" "}
          <a href="/" onClick={showFarhenheit}>
            °F
          </a>
        </span>
      </div>
    );
  } else {
    let farhenheit = (props.celsius * 9) / 5 + 32;
    return (
      <div className="WeatherTemperature">
        <span className="temperature">{Math.round(farhenheit)}</span>
        <span className="unit">
          °F |{" "}
          <a href="/" onClick={showCelcius}>
            °C
          </a>
        </span>
      </div>
    );
  }
}
